import { ApplicationData } from './application-data';
import { Validator } from './validator';

export class LocationValidator implements Validator {
    public validate(data: ApplicationData): boolean {
        const hasSubsidyPlace = data.packages.some(x => x.isSubsidyPlace);
        return !!data.packages?.length && (!hasSubsidyPlace || (data.municipality && data.municipality !== null && data.municipality !== '')) ;
    }
}
